import { setContext } from '@apollo/client/link/context';
import { omit } from 'lodash-es';

import { NO_AUTH_REQUIRED } from 'enums/apollo';

import { getDefaultHeaders } from 'store/api/ApiRequest';

export const authLink = () =>
  setContext(async (_, { authToken, headers }) => {
    const defaultHeaders = { ...getDefaultHeaders() };

    if (headers === NO_AUTH_REQUIRED) {
      return { headers: omit(defaultHeaders, 'Authorization') };
    }

    if (authToken) {
      defaultHeaders.Authorization = `Bearer ${authToken}`;
    }

    return { headers: { ...defaultHeaders, ...headers } };
  });
